<template>
  <section>
    <iframe v-if="basePath !== undefined" :src="stayTunedLink" width="100%" height="100%" frameborder="0"></iframe>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'StayTuned',
  props: {
  },
  computed: {
    ...mapState('poll', ['basePath']),
    ...mapGetters('poll', ['stayTunedLink'])
  }
}
</script>

<style scoped lang="scss">
section {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.style-bbl,
.style-veev {

  section {
    display: none;
  }
}
</style>
